import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

/**
 * @file Created on Tue Oct 23 2018
 * @author PSe
 * @author Tomas Leity
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { EntityChangeConverter, EntityChangeSetInfoConverter, jsonConversions, LockActionResultConverter, PortionDTOConverter, PromotionAreaConverter, PromotionConverter, PromotionFilterConverterImpl, PromotionStatusConverter, ResultWithOverviewConverterImpl, ValidationResultConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../logger';
import { CRUTransportLayer } from '../CRUTransportLayer';
export var PromotionLayer =
/*#__PURE__*/
function (_CRUTransportLayer) {
  _inherits(PromotionLayer, _CRUTransportLayer);

  function PromotionLayer() {
    var _this;

    _classCallCheck(this, PromotionLayer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionLayer).call(this, CONSTANTS.API.ENDPOINTS.PROMOTIONS));
    /**
     * Create new Promotion with/without OPEN state
     * @param promotion - new Promotion
     * @param open - open state
     */

    _this.createPromotion = function (promotion, open) {
      var path = CONSTANTS.API.ENDPOINTS.PROMOTIONS;
      return api(open ? "".concat(path, "?open=true") : path).post(_this.converter.toDocument(promotion, jsonConversions), {
        responseType: 'json'
      }).then(function (response) {
        return _this.converter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };
    /**
     * Gets all Promotions suitable for simulation
     */


    _this.getSimulated = function (filter) {
      return api(CONSTANTS.API.ENDPOINTS.FORECAST_SIMULATION_PROMOTIONS).post(filter, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };
    /**
     * Gets all filtered Promotions based on the filter.
     * @returns Promise with fetched Windows.
     */


    _this.filter = function (overview) {
      var checkPrivileges = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var resultWithOverviewConverter = new ResultWithOverviewConverterImpl(_this.converter, new PromotionFilterConverterImpl());
      return api(CONSTANTS.API.ENDPOINTS.PROMOTIONS_FILTER).post({
        overview: overview,
        checkPrivileges: checkPrivileges
      }, {
        responseType: 'json'
      }).then(function (response) {
        return resultWithOverviewConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };
    /**
     * Deletes one particular item based on Promotion id
     * @param id
     */


    _this.delete = function (id) {
      return api(CONSTANTS.API.ENDPOINTS.PROMOTIONS_SINGLE(id)).delete().then(function () {
        return Promise.resolve();
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };
    /**
     * Locks one particular item based on Promotion id
     * @param id
     */


    _this.lockPromotion = function (id) {
      return api(CONSTANTS.API.ENDPOINTS.PROMOTIONS_LOCK(id)).post({}, {
        responseType: 'json'
      }).then(function (response) {
        return _this.lockActionConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };
    /**
     * Unlocks one particular item based on Promotion id
     * @param id
     */


    _this.unlockPromotion = function (id) {
      return api(CONSTANTS.API.ENDPOINTS.PROMOTIONS_UNLOCK(id)).post({}, {
        responseType: 'json'
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };
    /**
     * Gets overview of Promotions based on filter
     * @param filter
     */


    _this.overview = function (filter) {
      return api(CONSTANTS.API.ENDPOINTS.PROMOTIONS_OVERVIEW).post(filter, {
        responseType: 'json'
      }).then(function (response) {
        return response.data.result || [];
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };
    /**
     * Gets workflow states of specific promotion
     * @param promotionIds
     */


    _this.workflowStates = function (promotionIds) {
      return api(CONSTANTS.API.ENDPOINTS.PROMOTIONS_WORKFLOW_STATES).post({
        ids: promotionIds
      }, {
        responseType: 'json'
      }).then(function (response) {
        return (response.data.result || []).map(function (item) {
          return _this.workflowConverter.toObject(item, jsonConversions);
        });
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };
    /**
     * Gets change history set info based on promotionId
     * @param promotionId
     */


    _this.changeHistory = function (promotionId) {
      return api(CONSTANTS.API.ENDPOINTS.PROMOTIONS_CHANGE_HISTORY(promotionId)).get({
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this.entityChangeSetConverter.toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };
    /**
     * Gets change history set based on promotionId & setId
     * @param promotionId
     * @param setId
     */


    _this.changeHistorySet = function (promotionId, setId) {
      return api(CONSTANTS.API.ENDPOINTS.PROMOTIONS_CHANGE_HISTORY_SET(promotionId, setId)).get({
        responseType: 'json'
      }).then(function (response) {
        return _this.entityChangeConverter.toObject(response.data.result[0], jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };
    /**
     * Fetches assigned shelfspaces
     * @param promotionIds {Array<string>}
     */


    _this.findAssignedPromotionAreas = function (promotionIds) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var _ref, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return api(CONSTANTS.API.ENDPOINTS.PROMOTIONS_ASSIGNED_AREAS).post({
                  promotionIds: promotionIds
                }, {
                  responseType: 'json'
                });

              case 3:
                _ref = _context.sent;
                data = _ref.data;
                return _context.abrupt("return", (data.result || []).map(function (item) {
                  return _this2.promotionAreaConverter.toObject(item, jsonConversions);
                }));

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                logger.error(_context.t0);
                return _context.abrupt("return", Promise.reject(_context.t0));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }));
    };
    /**
     * Fetches assigned shelfspaces
     * @param promotionIds {Array<string>}
     */


    _this.unlockPromotions = function (promotionIds) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return api(CONSTANTS.API.ENDPOINTS.PROMOTIONS_UNLOCK_SOME).post({
                  promotionIds: promotionIds
                }, {
                  responseType: 'json'
                });

              case 3:
                _context2.next = 9;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](0);
                logger.error(_context2.t0);
                return _context2.abrupt("return", Promise.reject(_context2.t0));

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 5]]);
      }));
    };
    /**
     * Fetches assigned shelfspaces
     * @param promotionIds {Array<string>}
     * @param promotionAreaIds {Array<string>}
     */


    _this.assignPromotionAreas = function (promotionIds, promotionAreaIds) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _ref2, data;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return api(CONSTANTS.API.ENDPOINTS.PROMOTIONS_AREAS_ASSIGN).post({
                  promotionIds: promotionIds,
                  promotionAreaIds: promotionAreaIds
                }, {
                  responseType: 'json'
                });

              case 3:
                _ref2 = _context3.sent;
                data = _ref2.data;
                return _context3.abrupt("return", this.validationResultConverter.toObject(data.result, jsonConversions));

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);
                logger.error(_context3.t0);
                return _context3.abrupt("return", Promise.reject(_context3.t0));

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 8]]);
      }));
    };
    /**
     * Copy shelfspaces from one PromoGroup to another
     * @param sourcePromotionIds {Array<string>}
     * @param targetPromotionIds {Array<string>}
     */


    _this.copyPromotionAreas = function (sourcePromotionIds, targetPromotionIds) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _ref3, data;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return api(CONSTANTS.API.ENDPOINTS.PROMOTIONS_AREAS_COPY).post({
                  sourcePromotionIds: sourcePromotionIds,
                  targetPromotionIds: targetPromotionIds
                }, {
                  responseType: 'json'
                });

              case 3:
                _ref3 = _context4.sent;
                data = _ref3.data;
                return _context4.abrupt("return", this.validationResultConverter.toObject(data.result, jsonConversions));

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);
                logger.error(_context4.t0);
                return _context4.abrupt("return", Promise.reject(_context4.t0));

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 8]]);
      }));
    };
    /**
     * Validate if You can same shelfspaces to current promotions
     * @param promotionIds {Array<string>}
     * @param tryLock check and lock all categories
     */


    _this.promotionAreasCheck = function (promotionIds, tryLock) {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var _ref4, data;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return api(CONSTANTS.API.ENDPOINTS.PROMOTIONS_AREAS_CHECK).post({
                  promotionIds: promotionIds,
                  tryLock: tryLock
                }, {
                  responseType: 'json'
                });

              case 3:
                _ref4 = _context5.sent;
                data = _ref4.data;
                return _context5.abrupt("return", this.validationResultConverter.toObject(data.result, jsonConversions));

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](0);
                logger.error(_context5.t0);
                return _context5.abrupt("return", Promise.reject(_context5.t0));

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 8]]);
      }));
    };

    return _this;
  }

  _createClass(PromotionLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
    /**
     * Gets workflow state of specific promotion
     * @param promotionId
     */

  }, {
    key: "workflowState",
    value: function workflowState(promotionId) {
      var _this3 = this;

      return api(CONSTANTS.API.ENDPOINTS.PROMOTIONS_WORKFLOW_STATE(promotionId)).get({
        responseType: 'json'
      }).then(function (response) {
        return _this3.workflowConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Calls one of the Promo actions
     * @param promotionId
     * @param actionType
     */

  }, {
    key: "action",
    value: function action(promotionId, actionType) {
      return api(CONSTANTS.API.ENDPOINTS.PROMOTIONS_ACTION).post({
        promotionId: promotionId,
        actionType: actionType
      }, {
        responseType: 'json'
      });
    }
  }]);

  return PromotionLayer;
}(CRUTransportLayer);

__decorate([Inject, __metadata("design:type", PromotionConverter)], PromotionLayer.prototype, "converter", void 0);

__decorate([Inject, __metadata("design:type", PromotionStatusConverter)], PromotionLayer.prototype, "workflowConverter", void 0);

__decorate([Inject, __metadata("design:type", LockActionResultConverter)], PromotionLayer.prototype, "lockActionConverter", void 0);

__decorate([Inject, __metadata("design:type", EntityChangeConverter)], PromotionLayer.prototype, "entityChangeConverter", void 0);

__decorate([Inject, __metadata("design:type", EntityChangeSetInfoConverter)], PromotionLayer.prototype, "entityChangeSetConverter", void 0);

__decorate([Inject, __metadata("design:type", PromotionAreaConverter)], PromotionLayer.prototype, "promotionAreaConverter", void 0);

__decorate([Inject, __metadata("design:type", ValidationResultConverter)], PromotionLayer.prototype, "validationResultConverter", void 0);

__decorate([Inject, __metadata("design:type", PortionDTOConverter)], PromotionLayer.prototype, "portionConverter", void 0);